import { ChildDropDownItem } from './child-dropdown-item.model';


export class DropDownItem {
    constructor(
        public id?: string,
        public taxonomy_value_id?: string,
        public name: string = '',
        public code: string = '',
        public childItems: ChildDropDownItem[] = []) { }
}
